import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Create a new Order.
 *
 * @private
 */
export const getExportOrderColumns = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.order.ExportOrderColumnsDef,
  // First argument to the payload creator
  {
    orderIds: string[]
    executedOrdersOnly: boolean
  },
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/order/getExportOrderColumns', async (params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const { orderIds, executedOrdersOnly } = params

    const response = await rpc('rpc/order/getExportOrderColumns', {
      category: 'rpc',
      type: 'rpc/order/getExportOrderColumns',
      payload: {
        orderIds,
        executedOrdersOnly,
      },
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {getExportOrderColumns}`,
      { tags: ['rpc', 'order'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `getExportOrderColumns failed`,
      error,
    })
  }
})
